(($, Drupal) => {
    Drupal.behaviors.categories = {
        attach: function attach() {
            setHistory($(".pagination__label"), "pagination-input", false);
            setHistory($(".categories__wrapper .form-radio"), "categories-input", true);
            /* setHistory($(".categories__belows-input"), "categories-belows-input"); */

            function setHistory(inputs, once, getValue) {
                inputs.once(once).each(function() { 
                    const element = $(this);
                    const stateLink = element.prop("href");
                    
                    
                    const stateId = element.prop("id");
                    const stateName = element.prop("name");
                    const stateValue = element.prop("value");
                    /* if(stateId == getHashState(stateName))
                        element.prop("checked", true) */
                    element.on("click", function() {
                        pushSimpleHash(!getValue ? stateLink : "?" + stateName + "=" + stateValue);
                        /* pushHashState({ stateElement: element.prop("id") }, stateName, stateId); */
                    });
                });
            }

            let elems;
            window.onpopstate = function(event) {
                if(event.state) {
                    const element = $("#" + event.state.stateElement);
                    const label = $("label[for=" + event.state.stateElement + "]");
                    const line = $(element.parent().find(".categories__line"));
    
                    element.prop("checked", true);
                    updateLine(line, label);
                    elems = element;
                }
                else {
                    const element =  $($("input[name=" + elems.prop("name") + "]")[0]).prop("checked", true);
                    const label = $("label[for=" + element.prop("id") + "]");
                    const line = $(element.parent().find(".categories__line"));
                    element.prop("checked", true);
                    updateLine(line, label);
                }
            };

            $(".categories__values.main__slider").once("categories-values").each(function() {
                const categories = $(this);
                
                categories.find("." + sliderClasses.navContainerClass).addClass('default__nav absolute');
                

                    $(window).on("resize load", function() {
                        if(categories.data('owl.carousel')) {
                            if($(window).innerWidth() <= 1024 && $(window).innerWidth() > 768)
                            {
                                categories.data('owl.carousel').options.margin = 16;
                                categories.data('owl.carousel').options.items = 2;
                                categories.data('owl.carousel').options.nav = true;
                                categories.trigger('refresh.owl.carousel');
                            }
                            else if($(window).innerWidth() <= 768) {
                                categories.data('owl.carousel').options.margin = 16;
                                categories.data('owl.carousel').options.items = 1;
                                categories.data('owl.carousel').options.nav = true;
                                categories.trigger('refresh.owl.carousel');
                            }
                            else {
                                categories.data('owl.carousel').options.margin = 32;
                                categories.data('owl.carousel').options.items = categories.data("columns");
                                categories.data('owl.carousel').options.nav = true;
                                categories.trigger('refresh.owl.carousel');
                            }
                        }
                    })


            });
        }
    };

})(jQuery, Drupal);
  